import { MatSelectConfig } from '@angular/material/select';

/**
 * Time to wait after the last keystroke before matching a typed letter to an option.
 * Material's default delay can discard the match if the select loses focus first.
 * (Default: 200ms)
 */
export const EWA_MAT_SELECT_DEFAULT_OPTIONS: MatSelectConfig = {
    typeaheadDebounceInterval: 0,
};
